import { render, staticRenderFns } from "./EModalExportarAula.vue?vue&type=template&id=99869c0a"
import script from "./EModalExportarAula.vue?vue&type=script&lang=js"
export * from "./EModalExportarAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports